import React, { useState } from 'react';
import { API_URL } from '../../../config/api';
import TechStackModal from '../../TechStackModal';

/**
 * FirmTechStackWidget — compact version of the tech-stack tab section.
 * Shows execution type, FPGA, languages, and data sets as chips, with an
 * edit button that opens the existing TechStackModal.
 * Data contract: PUT /firms/:id/tech-stack.
 */
export default function FirmTechStackWidget({ firm, firmId, onRefresh }) {
    const [editOpen, setEditOpen] = useState(false);
    const token = localStorage.getItem('authToken');
    const ts = firm.techStack;

    const handleSave = async (techStackData) => {
        const res = await fetch(`${API_URL}/firms/${firmId}/tech-stack`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
            body: JSON.stringify(techStackData),
        });
        if (!res.ok) throw new Error('Failed to save tech stack');
        setEditOpen(false);
        onRefresh?.();
    };

    return (
        <div>
            <div className="flex items-center justify-end mb-2">
                <button onClick={() => setEditOpen(true)} className="text-xs font-medium text-emerald-700 hover:text-emerald-800">
                    {ts ? 'Edit' : '+ Add'}
                </button>
            </div>

            {ts ? (
                <div className="space-y-3">
                    <div className="grid grid-cols-2 gap-2">
                        <div className="px-2 py-1.5 bg-gray-50 rounded">
                            <div className="text-[10px] text-gray-500">Execution Type</div>
                            <div className="text-sm text-gray-800 font-medium">{ts.executionType || '—'}</div>
                        </div>
                        <div className="px-2 py-1.5 bg-gray-50 rounded">
                            <div className="text-[10px] text-gray-500">FPGA</div>
                            <div className="text-sm text-gray-800 font-medium">{ts.fpgaEnabled ? 'Yes' : 'No'}</div>
                        </div>
                    </div>
                    <div>
                        <div className="text-[10px] font-medium text-gray-500 mb-1.5">Programming Languages</div>
                        <div className="flex flex-wrap gap-1.5">
                            {ts.programmingLanguages?.length > 0
                                ? ts.programmingLanguages.map((l, i) => <span key={i} className="px-2 py-0.5 bg-purple-50 text-purple-700 text-xs rounded font-medium border border-purple-200">{l}</span>)
                                : <span className="text-xs text-gray-400">None specified</span>}
                        </div>
                    </div>
                    <div>
                        <div className="text-[10px] font-medium text-gray-500 mb-1.5">Data Sets</div>
                        <div className="flex flex-wrap gap-1.5">
                            {ts.dataSets?.length > 0
                                ? ts.dataSets.map((d, i) => <span key={i} className="px-2 py-0.5 bg-green-50 text-green-700 text-xs rounded font-medium border border-green-200">{d}</span>)
                                : <span className="text-xs text-gray-400">None specified</span>}
                        </div>
                    </div>
                    {ts.notes && (
                        <div>
                            <div className="text-[10px] font-medium text-gray-500 mb-1">Notes</div>
                            <p className="text-sm text-gray-600">{ts.notes}</p>
                        </div>
                    )}
                </div>
            ) : (
                <p className="text-sm text-gray-400 text-center py-3">No tech stack information</p>
            )}

            {editOpen && <TechStackModal firm={firm} techStack={ts} onSave={handleSave} onClose={() => setEditOpen(false)} />}
        </div>
    );
}
